import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UsuarioModel } from '../models/usuario.model';

import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // singleWebApp asociada con el proyecto firebase :: sesiones-live-RED ::

  private url = 'https://identitytoolkit.googleapis.com/v1/accounts:';
  private apiKey = ' AIzaSyCL5SUEI-82qy7HpoGHVcIWjw_tvp3QTVc';

  userToken: string;

  // https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=[API_KEY]

  // https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=[API_KEY]

  constructor( private http: HttpClient ) { 
    this.leerToken();
  }

  login( usuario: UsuarioModel ){

    const authData = {
      email: usuario.email,
      password: usuario.password,
      returnSecureToken: true
    };

    return this.http.post(
      `${ this.url }signInWithPassword?key=${ this.apiKey }`,
      authData
      ).pipe(
        map( resp => {
          this.guardarToken( resp['idToken'] );
          return resp;
        })
      );

  }

  logout(){
    localStorage.removeItem('token');
    localStorage.expira = 0;  
  }

  nuevoUser( usuario: UsuarioModel ){

    const authData = {
      email: usuario.email,
      password: usuario.password,
      returnSecureToken: true
    };
    
    return this.http.post(
    `${ this.url }signUp?key=${ this.apiKey }`,
    authData
    ).pipe(
      map( resp => {
        this.guardarToken( resp['idToken'] );
        return resp;
      })
    );
  }

  private guardarToken( idToken: string ){
    this.userToken = idToken;
    localStorage.setItem('token', idToken);

    let hoy = new Date();
    hoy.setSeconds( 3600 );
    localStorage.setItem( 'expira', hoy.getTime().toString() );
  }

  leerToken(){
    if ( localStorage.getItem('token') ){
      this.userToken = localStorage.getItem('token');
    }else {
      console.log("no existía el token");
      this.userToken = '';
    }
    return this.userToken;
  }

  userAutenticado():boolean{
    if( this.userToken.length < 2 ){
      return false;
    }else {
      // console.log(`${ this.userToken } si es mayor a 2`);
      console.log("login active");
    }
    const expira = Number(localStorage.getItem('expira'));
    const expiraDte = new Date();
    expiraDte.setTime(expira);

    if( expiraDte > new Date() ){
      return true;
    } else {
      return false;
    }

  }
}
